module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedBold.28520b4.eot";